// extracted by mini-css-extract-plugin
export default {"wrap":"Pagination_wrap__TDPe1","dot":"Pagination_dot__i11rG","active":"Pagination_active__IrlkA"};